var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex flex-col overflow-auto"},[_c('block-editor',{ref:"editor",attrs:{"config":_vm.config,"initialized":_vm.onInitialized}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }